module.exports = __webpack_public_path__ + "assets/img/thumb-Pop-Menu-Landing-Page-+-Website.cb8d87fd.jpg";